<script>
import BasicSelect from "./BasicSelect.vue";

export default {
  name: "LanguageSelect",
  components: {
    BasicSelect
  },
  watch: {
    model: function (val) {
      this.$emit('change', val)
      this.$emit('input', val)
    },
    value: function (val) {
      this.model = val;
    },
    list: function (val) {
      this.model = val.find(item => item.code === document.documentElement.lang);
    }
  },

  data() {
    return {
      list: [],
      model: document.documentElement.lang
    }
  },
  mounted() {
    axios.get('/glossary/languages?order_by=language.name').then(({data}) => {
      this.list = Object.keys(data.data).map(key => ({
        code: key,
        label: data.data[key]
      }));
    })
  }
}
</script>

<template>
  <basic-select :simple="true" v-model="model" :options="list" code="code" text="label" :label="'Language'" :placeholder="'Select your language'">
    <template #selected-option="{option}">
      <div class="d-flex align-items-center gap-2">
        <i class="fi fi-rr-globe"></i>
        <span>{{ option.label }}</span>
      </div>
    </template>
  </basic-select>
</template>

<style scoped>

</style>